import { useEffect } from 'react';

export const PageReload = () => {
  useEffect(() => {
    window.location.reload();
  }, []);

  return null;
};
